import { render, staticRenderFns } from "./social-media-links.component.vue?vue&type=template&id=21c280cd&scoped=true&"
import script from "./social-media-links.component.vue?vue&type=script&lang=js&"
export * from "./social-media-links.component.vue?vue&type=script&lang=js&"
import style0 from "./social-media-links.component.vue?vue&type=style&index=0&id=21c280cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c280cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
